import { render } from "./NetworkMapSectors.vue?vue&type=template&id=18aa447f&scoped=true&ts=true"
import script from "./NetworkMapSectors.vue?vue&type=script&lang=ts"
export * from "./NetworkMapSectors.vue?vue&type=script&lang=ts"

import "./NetworkMapSectors.vue?vue&type=style&index=0&id=18aa447f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18aa447f"]])

export default __exports__